import React, { useEffect } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"

import WrapperSkeleton from "../WrapperSkeleton/"

import { getCustomer } from "services/state/actions"
import { sendGtmUserData } from "services/utils/sendGtm"

const CustomerProvider = ({ customer, getCustomer, children, path }) => {
  useEffect(() => {
    if (_isEmpty(customer.data)) {
      getCustomer()
      sendGtmUserData()
    }
  }, [])

  useEffect(() => {
    if (window.newrelic && !_isEmpty(customer.data)) {
      const documentNumber = _get(customer, ["data", "documentNumber"], "")
      window.newrelic.setUserId(documentNumber)
    }
  }, [customer, window.newrelic])

  return (
    <WrapperSkeleton
      path={path}
      isChildrenReady={customer.data && !customer.loading}
    >
      {children}
    </WrapperSkeleton>
  )
}

CustomerProvider.propTypes = {
  customer: PropTypes.object,
  getCustomer: PropTypes.func,
  children: PropTypes.node,
  path: PropTypes.string
}

const mapStateToProps = ({ customer }) => ({
  customer
})

const enhance = compose(connect(mapStateToProps, { getCustomer }))

export default enhance(CustomerProvider)



// WEBPACK FOOTER //
// ./src/components/CustomerProvider/index.js